export const ROUTES = {
  MAIN: '/welcome-page',
  REQUEST_QUOTE: '/request-a-quote',
  EXISTING_ORDER: '/existing-order',
  ADMIN_PORTAL: '/admin-portal',
  LOGIN: '/login',
  REQUEST_QUOTE_TO_ORDER: '/request-quote-to-order',
  MEMBER_VERIFICATION: '/member-verification',
  COSTCO_DASHBOARD: '/admin-dashboard',
  MILITARY_VERIFICATION: '/military/verify/:verificationId',
  MILITARY_CALLBACK: '/military/callback',
};
